module.exports = __webpack_public_path__ + "static/faq-banner-1f7f3c21791580010eb5e07676e5a426.jpg";